import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  Budget,
  BudgetPeriod,
  DateLabelNullable,
} from "@/services/cloudchipr.api";
import {
  setResourceExplorerDates,
  setResourceExplorerFilterTree,
} from "@/store/resource-explorer/resourceExplorerSlice";
import { addIdsToFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/addIdsToFilterTreeItems";

export const setResourceExplorerDataByBudget = createAsyncThunk(
  "resourceExplorer/initiateResourceExplorer",
  async (budget: Budget, { dispatch }) => {
    const budgetFilterTree = budget?.filter_tree;

    if (budgetFilterTree) {
      dispatch(
        setResourceExplorerFilterTree(
          addIdsToFilterTreeItems(budgetFilterTree),
        ),
      );
    }
    const period = budget.period;
    if (period === "custom") {
      dispatch(
        setResourceExplorerDates({
          from: budget.start_date,
          to: budget.end_date,
        }),
      );
    }
    if (budgetPeriodToDates?.[period]) {
      dispatch(
        setResourceExplorerDates({
          label: budgetPeriodToDates?.[period],
        }),
      );
    }
  },
);

const budgetPeriodToDates: Partial<Record<BudgetPeriod, DateLabelNullable>> = {
  monthly: "month_to_date",
  quarterly: "quarter_to_date",
  annually: "year_to_date",
};
